import React from "react";

import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../../general/Loading";
import DataTable from "react-data-table-component";
import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Line } from 'react-chartjs-2';
/*import CanvasJSReact from '../../../../canvasjs.react';
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;*/

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Title);


function EstadisticasAgenda() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [idItemEliminar, setIdItemEliminar] = useState();
    const [modalContainerStatus,setModalContainerStatus] = useState('');
    const [modalBackdropStatus,setModalBackdropStatus] = useState('zindex-back');

    const [terminoBusqueda, setTerminoBusqueda] = useState('');

    const [asd, setAsdf] = useState();

    const [options, setOptions] = useState();
    const [options2, setOptions2] = useState();

    const [citasPorEstado, setCitasPorEstado] = useState([]);
    const [citasPorMes, setCitasPorMes] = useState({});

    
    /*CanvasJS.addCultureInfo("es",
                {
                    decimalSeparator: ".",
                    digitGroupSeparator: ",",
                    days: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
                    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
               });*/
    

    let userdata = [];
    let clientData = [];

    const cols = [
        { name:'Nombre', selector:row => row.nombre, sortable:true },
        { name:'Código', selector:row => row.codigo_empresa, sortable:false },
        { name:'Acción', cell:row => getBotones(row), minWidth: '32%' }
    ];

    const getBotones = (item) => {
        
        return (
            <>
            <Link to={'/aseguradora?id='+item.id} className="btn btn-primary btn-sm"><i className="far fa-edit"></i>&nbsp;Editar</Link>&nbsp;
            <Link to={'#'} onClick={() => showModal(item.id)} className="btn btn-primary btn-sm"><i className="fas fa-trash-alt"></i>&nbsp;Eliminar</Link>
            </>
        )
    }

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    //setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });
        
        

        axios.get('estado-citas?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setCitasPorEstado(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('citas-por-mes?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setCitasPorMes(response.data[0]);
                    
                }
            })
            .catch(error => {
                console.log(error);
            });

        
        /*const grafico = {
            animationEnabled: true,
            //exportEnabled: true,
            theme: "light1", // "light1", "dark1", "dark2"
            title:{
                text: "Citas últimos 30 días"
            },
            data: [{
                type: "pie",
                indexLabel: "{label}: {y}%",		
                startAngle: -90,
                dataPoints: [
                    { y: 20, label: "Airfare" },
                    { y: 24, label: "Food & Drinks" },
                    { y: 20, label: "Accomodation" },
                    { y: 14, label: "Transportation" },
                    { y: 12, label: "Activities" },
                    { y: 10, label: "Misc" }	
                ]
            }]
        };

        var dataPoints =[{x:new Date(2022, 0),y:20},{x:new Date(2022, 1),y:8},{x:new Date(2022, 2),y:16},{x:new Date(2022, 3),y:32},{x:new Date(2022, 4),y:24},{x:new Date(2022, 5),y:24},{x:new Date(2022, 6),y:24},{x:new Date(2022, 7),y:24},{x:new Date(2022, 8),y:24},{x:new Date(2022, 9),y:24},{x:new Date(2022, 10),y:24},{x:new Date(2022, 11),y:24}];

        const grafico2 = {
            animationEnabled: true,
			theme: "light1",
			title: {
				text: "Total citas por mes"
			},
			axisY: {
				title: "Citas",
				//prefix: "$"
			},
			axisX: {
				valueFormatString: "MMM"
			},
			data: [{
				type: "line",
				//xValueFormatString: "MMM",
				//yValueFormatString: "$#,##0.00",
				dataPoints: dataPoints
			}]
		}*/

        


        

        

    },[]);



    useEffect(() => {

        const labels1 = [];
        const values1 = [];
        const colors1 = [];

        citasPorEstado.map((cp) => {
            labels1.push(cp.estado);
            values1.push(cp.cantidad_citas);
            colors1.push(cp.color);
        });

        const data1 = {
            labels: labels1,
            datasets: [
              {
                label: 'Dataset 1',
                data: values1,
                backgroundColor: colors1
              }
            ]
        };

        setOptions(data1);

    },[citasPorEstado]);



    useEffect(() => {

        const values1 = [];

        console.log('Citas por mes: ');
        console.log(citasPorMes);

        const data2 = {
            labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            datasets: [
                {
                label: 'Dataset 1',
                data: [citasPorMes.enero,citasPorMes.febrero,citasPorMes.marzo,citasPorMes.abril,citasPorMes.mayo,citasPorMes.junio,citasPorMes.julio,citasPorMes.agosto,citasPorMes.septiembre,citasPorMes.octubre,citasPorMes.noviembre,citasPorMes.diciembre],
                borderColor: '#3D636C',
                backgroundColor: '#AED9DE',
                }
            ],
        };

        setOptions2(data2);

    },[citasPorMes]);


    

    const showModal = (e) => {
        setModalContainerStatus('show');
        setModalBackdropStatus('show');
        setIdItemEliminar(e);
    }

    const cerrar = () => {
        setModalContainerStatus('');
        setModalBackdropStatus('zindex-back');
        setIdItemEliminar(null);
    }


    useEffect(() => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                termino: terminoBusqueda
            }
        }

        /*axios.get('/aseguradoras',config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.log(error);
            })*/

    },[terminoBusqueda]);



    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="reports" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/estadisticas">Estadísticas</Link></li>
                                        <li className="breadcrumb-item" key="bc3">Estadísticas de Agenda</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Estadísticas de Agenda</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-5 centrar bloque-grafico">

                                {/*<CanvasJSChart options={options} />*/}
                                
                                {/*<DataTable
                                columns={cols}
                                data={items}
                                pagination
                                id={'aseguradoras'}
                                />*/}

                                <h3>Citas en los últimos 30 días</h3>
                                <Pie data={options} />

                            </div>
                            <div className="col-md-5 centrar bloque-grafico">

                                <h3>Citas en los últimos 12 meses</h3>
                                <Line data={options2} />

                                {/*<CanvasJSChart options={options2} culture={'es'} />*/}

                            </div>          
                        </div>

                        </div>
                    </section>
                </div>


                {/*<div className={'modal-container modal fade in '+modalContainerStatus}>
                    <div className="modal-dialog">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h4 className="modal-title">Eliminar Aseguradora</h4>
                                <button type="button" className="close" onClick={() => cerrar()}>&times;</button>
                            </div>

                            <div className="modal-body">
                                ¿Desea eliminar la aseguradora?
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={() => eliminar(idItemEliminar)}>Aceptar</button>
                                <button type="button" className="btn btn-default" onClick={() => cerrar()}>Cancelar</button>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={'modal-backdrop fade '+modalBackdropStatus}></div>
                */}

                <Footer />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default EstadisticasAgenda;